<template>
  <v-col class="pa-0 pt-3">
    <div class="text-center">
      <v-icon size="small"
          :color="active ? 'gelb' : undefined"
          class="mx-auto"
          style="background-color: #f2f2f2;"
              @click="onClick"
      >
        {{complete||active ? (active ? 'mdi-circle' : 'mdi-check-circle') : 'mdi-checkbox-blank-circle-outline'}}
      </v-icon>
    </div>
    <div class="text-center body-2" @click="onClick">{{title}}</div>
  </v-col>
</template>

<script>
export default {
  name: "Step",
  props:{
    nr:Number,
    complete: Boolean,
    active: Boolean,
    title: String,
  },
  methods: {
    onClick(){
      this.$emit("click", this.nr);
    }
  }
}
</script>

<style scoped>

</style>